import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles/index';
import red from '@material-ui/core/colors/red';
import YellowWarning from "../../images/icons/yellowWarning.svg";
import Transition from './Transition';

const styles = (theme) => ({
	dialogPadding : {
		padding : 10,
		[theme.breakpoints.up('md')]: {
			padding : '20px 50px 20px 50px',
		}
	},
	dialogPaper : {
		overflow: 'scroll',
		width: '60%',
		maxWidth: '90%',
	},
	question : {
		padding: '20px 20px 10px 20px',
		fontWeight : 600,
		fontSize : 16,
		textAlign : 'right',
	},
	actions : {
		padding : 10,
	},
	warningButton : {
		borderRadius : 100,
		color: theme.palette.getContrastText(red[500]),
		backgroundColor: red[500],
		'&:hover': {
			backgroundColor: red[700],
		},
	},
	warning : {
		fontSize : 20,
		padding : 20,
		border : '1px solid #eee',
		backgroundColor : '#f7f7f7',
		borderRadius : 5,
		marginBottom : 20,
	},
	warningIcon : {
		display: 'inline-block',
		width: 36,
		height: 36,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight : 5,
		backgroundImage: `url('${YellowWarning}')`,
	},
});


class ConfirmInvalidateVendorBillDialog extends PureComponent {

	constructor (props) {
		super(props);
		this.state = {
			invalidReason : '',
		};
	}

	onChange = (event, fieldName) => {
		this.setState({ [fieldName] : event.target.value });
	};

	handleClose = () => {
		this.props.onClose();
	};

	handleInvalidate = () => {
		const {
			//onClose,
			showErrors,
			vendorBill,
			invalidateVendorBill,
		} = this.props;
		const { invalidReason } = this.state;

		if (!invalidReason) {
			showErrors(['A reason for marking bill invalid is required.']);
			return;
		}

		if (!vendorBill) {
			return showErrors(['Missing vendor bill']);
		}

		invalidateVendorBill({
			params : {
				invalidReason,
				vendorBillId : vendorBill.vendorBillId,
			},
			callback : (err) => {
				if (!err) {
					this.props.history.push(`/billing/vendorBills`);
				}
			}
		});
	};

	render() {
		const { classes, open, vendorBill } = this.props;

		if (!vendorBill) { return null; }
		return (
			<Dialog
				maxWidth='md'
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				classes={{
					paper: classes.dialogPaper
				}}
			>
				<DialogTitle>Invalidate Vendor Bill</DialogTitle>
				<DialogContent>
					{vendorBill.quickbooksBillId &&
					<div className={classes.warning}>
						<span className={classes.warningIcon}/>  <strong>IMPORTANT : </strong>This bill has already been exported to quickbooks.
						If you invalidate it in FMP you will <strong>ALSO</strong> need to invalidate
						this bill in quickbooks as well.
					</div>
					}

					<TextField
						value={this.state.invalidReason}
						onChange={event => this.onChange(event, 'invalidReason')}
						label="Reason for marking bill invalid"
						fullWidth
					/>
				</DialogContent>

				<div className={classes.question}>
					Are you sure you want to mark this bill invalid?
				</div>

				<DialogActions>
					<div className={classes.actions}>
						<Button onClick={this.handleClose}>
							Close
						</Button>
						<Button
							variant="contained"
							onClick={this.handleInvalidate}
							className={classes.warningButton}
						>
							Yes, mark bill as invalid
						</Button>
					</div>
				</DialogActions>
			</Dialog>
		);
	}
}

ConfirmInvalidateVendorBillDialog.propTypes = {
	open : PropTypes.bool,
	onClose : PropTypes.func.isRequired,
	classes: PropTypes.object.isRequired,

	//- Could be either
	vendorBill : PropTypes.object,
	history : PropTypes.object.isRequired,

	invalidateVendorBill : PropTypes.func.isRequired,
	showErrors : PropTypes.func.isRequired,
};

export default _.flow([
	withStyles(styles),
	withMobileDialog(),
])(ConfirmInvalidateVendorBillDialog);